import React, { useRef, useState } from 'react';
import DatahubAPI from 'api/DatahubAPI';
import EntityServiceAPI from 'api/EntityServiceAPI';
import { Link } from 'react-router-dom';

const SearchComp: React.FC = () => {
  const [ searchInput, setSearchInput ] = useState<string>('');
  const [ tab, setTab ] = useState<string>('People');
  const [ alias, setAlias ] = useState<string>('bite_app_entities_combined');
  const [ results, setResults ] = useState<any>({ isLoading: true, data: {} });

  const handleTabSwitch = (type: string) => {
    switch (type) {
    case 'People':
      setTab('People');
      setAlias('bite_app_entities_combined');
      break;
    case 'Imports':
      setTab('Imports');
      setAlias('bite_app_commodities_*');
      break;
    case 'Exports':
      setTab('Exports');
      setAlias('bite_app_commodities_*');
      break;
    default:
      setTab('People');
      setAlias('bite_app_entities_combined');
    }
  };

  const abbvSearch = async() => {
    const payload = {
      primary: searchInput,
      alias: alias,
      type:
        tab === 'Imports' ? 'US Import' : tab === 'Exports' ? 'US Export' : '',
    };
    // People & Companies (entities) goes through the new entity service;
    // Imports/Exports (products) still route through datahub.
    const res =
      tab === 'People'
        ? await EntityServiceAPI.abbvSearch(payload)
        : await DatahubAPI.abbvSearch(payload);
    if (res?.success) {
      setResults({ isLoading: false, data: res?.result });
    } else {
      setResults({ isLoading: false, data: {} });
    }
  };

  const handleEnterPress = (e: any) => {
    if (e.key === 'Enter' || e.which === 13) {
      abbvSearch();
    }
  };

  const inputRef = useRef<HTMLInputElement | null>(null);

  const handleClick = () => {
    inputRef.current?.focus();
  };

  const handleCloseResults = () => {
    setResults({ isLoading: true, data: {} });
  };

  return (
    <>
      <div className='home-search-frame'>
        <div className='home-search-frame-input-sec'>
          <div
            className='home-search-frame-input-sec-label'
            onClick={handleClick}
          >
            <input
              ref={inputRef}
              onChange={(e) => setSearchInput(e.target.value)}
              className='home-search-frame-input-sec-label-cont'
              placeholder='Search screening'
              onKeyUp={handleEnterPress}
            />
            <div className='home-search-frame-input-sec-label-cont-cmd'>
              <div className='home-search-frame-input-sec-label-cont-cmd-div'>
                <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'>
                  <path d='M17.5 17.5L14.5834 14.5833M16.6667 9.58333C16.6667 13.4954 13.4954 16.6667 9.58333 16.6667C5.67132 16.6667 2.5 13.4954 2.5 9.58333C2.5 5.67132 5.67132 2.5 9.58333 2.5C13.4954 2.5 16.6667 5.67132 16.6667 9.58333Z' stroke='var(--card-text)' strokeWidth='1.66667' strokeLinecap='round' strokeLinejoin='round'/>
                </svg>
              </div>
              <div className='home-search-frame-input-sec-cmd'>
                <div className='home-search-frame-input-sec-cmd-key'>
                  ↵/Enter
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='home-search-frame-input-action'>
          <div className='home-search-frame-input-action-sec'>
            <div className='home-search-frame-input-action-cont'>
              <div className='home-search-frame-input-action-cont-sec'>
                <div
                  onClick={() => handleTabSwitch('People')}
                  className={`home-search-frame-input-action-cont-btn ${
                    tab === 'People' ? 'selected' : ''
                  }`}
                >
                  People & Companies
                </div>
                <div
                  onClick={() => handleTabSwitch('Imports')}
                  className={`home-search-frame-input-action-cont-btn ${
                    tab === 'Imports' ? 'selected' : ''
                  }`}
                >
                  Imports
                </div>
                <div
                  onClick={() => handleTabSwitch('Exports')}
                  className={`home-search-frame-input-action-cont-btn ${
                    tab === 'Exports' ? 'selected' : ''
                  }`}
                >
                  Exports
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {!results.isLoading && (
        <div className='home-search-results-container'>
          <div className='home-search-results-frame'>
            <div className='home-search-results-header'>
              <div className='home-search-results-header-text'>Hits</div>
              <button
                type='button'
                className='home-search-results-close-btn'
                onClick={handleCloseResults}
                aria-label='Close search results'
              >
                ×
              </button>
            </div>
            <div className='home-search-results-body'>
              {results?.data?.result?.body?.aggregations?.lensAgg?.buckets?.map((lens: any, index: number) => (
                <>
                  {tab === 'People' && (
                    <Link
                      to={{
                        pathname: '/entity-screening',
                        state: {
                          linkTab: 'Entities',
                          primary: searchInput,
                          lenses:  results?.data?.result?.body?.aggregations?.lensAgg?.buckets[index].key
                        }
                      }}
                      style={{ width: '100%' }}
                    >
                      <div key={index} className='home-search-results-row'>
                        <div className='home-search-results-row-content'>
                          <div className='home-search-results-row-group'>
                            <div className='home-search-results-row-primary'>
                              {lens.key} -
                            </div>
                            <div className='home-search-results-row-secondary'>
                              {lens.doc_count.toLocaleString()}
                            </div>
                          </div>
                        </div>
                      </div>
                    </Link>
                  )}
                  {tab === 'Imports' && (
                    <Link
                      to={{
                        pathname: '/import-screening',
                        state: {
                          primary: searchInput,
                          lenses:  results?.data?.result?.body?.aggregations?.lensAgg?.buckets[index].key,
                        }
                      }}
                      style={{ width: '100%' }}
                    >
                      <div key={index} className='home-search-results-row'>
                        <div className='home-search-results-row-content'>
                          <div className='home-search-results-row-group'>
                            <div className='home-search-results-row-primary'>
                              {lens.key} -
                            </div>
                            <div className='home-search-results-row-secondary'>
                              {lens.doc_count.toLocaleString()}
                            </div>
                          </div>
                        </div>
                      </div>
                    </Link>
                  )}
                  {tab === 'Exports' && (
                    <Link
                      to={{
                        pathname: '/export-screening',
                        state: {
                          primary: searchInput,
                          lenses:  results?.data?.result?.body?.aggregations?.lensAgg?.buckets[index].key,
                        }
                      }}
                      style={{ width: '100%' }}
                    >
                      <div key={index} className='home-search-results-row'>
                        <div className='home-search-results-row-content'>
                          <div className='home-search-results-row-group'>
                            <div className='home-search-results-row-primary'>
                              {lens.key} -
                            </div>
                            <div className='home-search-results-row-secondary'>
                              {lens.doc_count.toLocaleString()}
                            </div>
                          </div>
                        </div>
                      </div>
                    </Link>
                  )}
                </>
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SearchComp;
